<script setup lang="ts">
import { useAuth } from "~/store/auth";
import { useSettings } from "~/store/settings";
import api from "~/utils/auth/api";
import t from "~/utils/translate";

const route = useRoute();
const settings = useSettings();
const auth = useAuth();
const successfulOptins = ref<string[]>([]);
const { $toast } = useNuxtApp();

watchEffect(() => {
	const { optin, register } = route.query;
	if (process.client && auth.hydrated) {
		if (optin && !successfulOptins.value.includes(optin as string)) {
			if (auth.loggedIn) {
				api({
					url: "/Marketing/InsertMarketingOptIn",
					type: "api",
					options: {
						method: "POST",
					},
					data: {
						countryCode: settings.getCountryConfig?.countryIsoTwo,
						optinName: optin,
						vendorAccountID: auth.profile?.id,
					},
				}).then(() => {
					successfulOptins.value = [...successfulOptins.value, optin as string];
					$toast.add({ severity: "success", summary: t("succesfully-opted-in"), life: 5000 });
				});
			} else if (!register) {
				auth.modals.login = true;
			}
		}
	}
});
</script>

<template><div /></template>
